export default "<button class=\"player__panel-button j-pic-in-pic\" title=\"Picture in Picture\">\n  <span class=\"icon-container\"></span>\n</button>\n"